import styled from 'styled-components';

const LoadingDotsWrapper = styled.div`
  align-self: center;
  text-align: center;
  margin: auto;
  width: 40px;
  display: block;
  padding: 0;

  > div {
    align-self: center;
    text-align: center;
  }
  
  @media only screen and (max-width: 425px) {
    > div > div {
      width: 6px;
      height: 6px;
    }
  }
`;

export {
  LoadingDotsWrapper,
};